import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Header from "../../components/header";
import axios from "axios";
import {ClipLoader} from "react-spinners";
import Select from "react-select";
import MainMenu from "../../components/MainMenu";
import {apiConfig} from "../../config";

import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import DateTimePicker from "react-datetime-picker";
import ProjectsStatComp from "./components/projectsStatistic";
import ProjectCallsStatComp from "./components/projectCallsStatistic";
import {OperatorStatComp} from "./components/OperatorStatComp";
import {CallsStatComp} from "./components/CallsStatComp";
import Dashboard from "./components/Dashboard";
import {SegmentsStatComp} from "./components/SegmentsStatComp";


const StatisticPage: React.FC = () => {
    const [selectedStat, setSelectedStat]: [any, any] = useState("4")

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100vh"}}>
            <Header title={"Статистика"}/>
            <div style={{display: "flex", flex: 1, flexDirection: "row"}}>
                <MainMenu />
                <div style={{display: "flex", height: 'calc(100vh - 60px)', flex: 1, flexDirection: "column"}}>
                  <div style={{display: "flex", flexDirection: "row", height: 50}}>
                    <button
                      onClick={() => {
                        setSelectedStat("4")
                      }}
                      style={{
                        display: "flex",
                        flex: 1,
                        borderWidth: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: selectedStat === "4" ? "white" : ""
                      }}>
                      Дашборд
                    </button>
                    <button
                      onClick={() => {
                        setSelectedStat("0")
                      }}
                      style={{
                        display: "flex",
                        flex: 1,
                        borderWidth: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: selectedStat === "0" ? "white" : ""
                      }}>
                      По операторам
                    </button>
                    <button
                      onClick={() => {
                        setSelectedStat("1")
                      }}
                      style={{
                        display: "flex",
                        flex: 1,
                        borderWidth: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: selectedStat === "1" ? "white" : ""
                      }}>
                      По звонкам
                    </button>
                    <button
                      onClick={() => {
                        setSelectedStat("2")
                      }}
                      style={{
                        display: "flex",
                        flex: 1,
                        borderWidth: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: selectedStat === "2" ? "white" : ""
                      }}>
                      Проекты и звонки
                    </button>
                    <button
                      onClick={() => {
                        setSelectedStat("3")
                      }}
                      style={{
                        display: "flex",
                        flex: 1,
                        borderWidth: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: selectedStat === "3" ? "white" : ""
                      }}>
                      Проекты
                    </button>
                    <button
                      onClick={() => {
                        setSelectedStat("5")
                      }}
                      style={{
                        display: "flex",
                        flex: 1,
                        borderWidth: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: selectedStat === "5" ? "white" : ""
                      }}>
                      По сегментам
                    </button>
                  </div>
                  {selectedStat === "4" && <Dashboard/>}
                  {selectedStat === "1" && <CallsStatComp/>}
                  {selectedStat === "0" && <OperatorStatComp/>}
                  {selectedStat === "2" && <ProjectCallsStatComp/>}
                  {selectedStat === "3" && <ProjectsStatComp/>}
                  {selectedStat === "5" && <SegmentsStatComp/>}
                </div>
            </div>
        </div>
    );
};


export default StatisticPage;
